import { Endpoint, HttpApi, HttpEndpoint, s } from "@kosmod/pancake";
import { GameID } from "@kosmod/sesame";

import { MiniTemplate, MiniTemplateID } from "./mini";
import { AnyLogicState } from "./logic/all";
import { DiceTemplate, DiceTemplateID } from "@kosmod/andy";
import { TerrainBrush, TerrainBrushID } from "./terrainBrush";
import { MiniModel, MiniModelID, MiniSprite, MiniSpriteID } from "./miniRender";
import { AssetReference } from "@kosmod/assets";
import { K3D } from "@kosmod/graphics-3d";

export const theatreAPI = HttpApi.Branch({
  'mini/templates': HttpEndpoint.Json({
    GET: {
      query: s.o({ game: GameID, templateId: s.optional(MiniTemplateID) }),
      request: s.null,
      response: s.o({
        minis: s.a(MiniTemplate)
      })
    },
    POST: {
      query: s.null,
      request: s.o({
        game: GameID,
        name: s.str,
        logic: s.a(AnyLogicState),
      }),
      response: s.o({
        mini: MiniTemplate
      })
    },
    PUT: {
      query: s.o({ game: GameID, templateId: MiniTemplateID }),
      request: s.o({
        name: s.str,
        logic: s.a(AnyLogicState),
      }),
      response: s.o({
        
      })
    },
  }),
  'mini/sprites': HttpApi.Methods({
    'GET': Endpoint.Json({
      query: s.o({ game: GameID, miniSpriteId: s.optional(MiniSpriteID) }),
      responseBody: s.o({
        miniSprites: s.a(MiniSprite)
      })
    }),
    'POST': Endpoint.Json({
      requestBody: s.o({
        game: GameID,
        imageAsset: AssetReference,
        imageArea: s.optional(K3D.Box2),
      }),
      responseBody: s.o({
        miniSprite: MiniSprite
      })
    }),
  }),
  'mini/models': HttpApi.Methods({
    'GET': Endpoint.Json({
      query: s.o({ game: GameID, miniModelId: s.optional(MiniModelID) }),
      responseBody: s.o({
        miniModels: s.a(MiniModel)
      })
    }),
    'POST': Endpoint.Json({
      requestBody: s.o({
        game: GameID,
        modelAsset: AssetReference,
        modelPath: s.a(s.str),
      }),
      responseBody: s.o({
        miniModel: MiniModel
      })
    }),
  }),
  'dice/templates': HttpApi.Methods({
    'GET': Endpoint.Json({
      query: s.o({ game: GameID, templateId: s.optional(DiceTemplateID) }),
      responseBody: s.o({
        dice: s.a(DiceTemplate)
      })
    }),
    'POST': Endpoint.Json({

    }),
  }),
  'terrain/brushes': HttpApi.Methods({
    'GET': Endpoint.Json({
      query: s.o({ game: GameID, brushId: s.optional(TerrainBrushID) }),
      responseBody: s.o({
        brushes: s.a(TerrainBrush)
      })
    }),
    'POST': Endpoint.Json({
      
    }), 
  }),
})


export type TheatreClient = HttpApi.Handler<"client", typeof theatreAPI>;

